import script from "./TailoringOrder.vue?vue&type=script&lang=js"
export * from "./TailoringOrder.vue?vue&type=script&lang=js"

import "./TailoringOrder.vue?vue&type=style&index=0&id=2bf5049f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bf5049f"]])

export default __exports__